module.exports = __webpack_public_path__ + "static/media/iconfont.9bea22dd.svg";